import ImageCarouselStepper from './ImageCarouselStepper';

export default ImageCarouselStepper;
